import styled from "styled-components";
import { 
  Box as MuiBox,
  Typography as MuiTypography,
  Divider as MuiDivider
} from "@mui/material";

export const Box = styled(MuiBox)`
  &.MuiBox-root {
    padding: 17px 0;
    width: 100%;
    max-height: 62px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }
`;

export const Typography = styled(MuiTypography)`
  &.MuiTypography-root {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 28px;
    color: #1C1B1F;
  }
`;

export const Divider = styled(MuiDivider)`
  &.MuiDivider-root {
    background: rgba(33, 33, 33, 0.08);
    width: 100%
    margin-bottom: 12px;
  }
`;

export const Wrap = styled(MuiBox)`
  &.MuiBox-root {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
`;

export const ColorBox = styled(MuiBox)`
  &.MuiBox-root {
    width: 100%;
    height: 10px;
    margin-top: 16px;
    background-color: skyblue;
  }
`;
